<template>
  <v-card height="100%" elevation="0">
    <v-row no-gutters style="margin: 0 14%; margin-top: 3.64%" align="center">
      <v-col
        cols="auto"
        style="background: #00857c; align-items: center; border-radius: 5px"
        :style="`${topLeftCard};${headingFourFont}`"
        class="white--text d-flex"
        ><span style="margin-left: 20%">Join trials</span></v-col
      ><v-spacer></v-spacer>
      <v-col
        cols="auto"
        style="background: #f7f7f7; align-items: center; border-radius: 5px"
        :style="`${headingFourFont};${topRightCard}`"
        class="d-flex"
        ><span style="margin-left: 4%"
          >We’ll ask a few questions about you to determine the trials that may
          match</span
        ></v-col
      >
    </v-row>
    <v-row no-gutters style="margin: 0 14%; margin-top: 3.64%" align="center">
      <div id="stepper-parent">
        <div class="stepper">
          <div class="timeline">
            <div
              class="step"
              v-for="(step, index) in steps"
              :key="index"
              :class="{
                active: currentStep === index,
                completed: currentStep > index,
              }"
            >
              <div class="step-icon" @click="changeStep(index)">
                <i v-if="currentStep > index" class="material-icons">check</i>
                <span v-else>{{ index + 1 }}</span>
              </div>

              <div class="line" v-if="index !== steps.length - 1"></div>
            </div>
          </div>
          <div class="step-content">
            <div v-if="currentStep === 0">
              <span :style="paragraphOneFont">{{
                steps[currentStep].title
              }}</span>
              <div class="step-buttons">
                <v-form ref="firstStepRef" style="width: 40vw">
                  <v-text-field
                    style="min-width: 160px"
                    placeholder="Enter your condition"
                    v-model="join_trials_inputs.condition"
                    :rules="rules.conditionRules"
                  ></v-text-field>
                </v-form>
                <!-- <v-combobox
                  v-model="steps[currentStep].input"
                  :items="items"
                  placeholder="Enter your condition"
                  :style="paragraphTwoFont"
                  :append-icon="null"
                ></v-combobox> -->
                <button
                  v-if="currentStep < steps.length - 1"
                  @click="goToSecondStep()"
                  style="margin-left: 1vw"
                >
                  Next
                </button>
              </div>
            </div>
            <div v-if="currentStep === 1">
              <v-form ref="secondStepRef" style="width: 40vw">
                <span :style="paragraphOneFont">{{
                  steps[currentStep].checkbox_title
                }}</span>
                <v-row style="width: 20vw">
                  <v-col class="pt-0 pr-0 pb-0">
                    <v-checkbox
                      v-model="join_trials_inputs.trials_for"
                      value="for_me"
                      label="For me"
                      color="#00857c"
                      :rules="rules.trialsForCheckboxRules"
                    >
                    </v-checkbox
                  ></v-col>
                  <v-col class="pt-0 pr-0 pb-0">
                    <v-checkbox
                      v-model="join_trials_inputs.trials_for"
                      label="For Someone else"
                      value="for_someone"
                      color="#00857c"
                      :rules="rules.trialsForCheckboxRules"
                      hide-details
                    >
                    </v-checkbox
                  ></v-col>
                </v-row>
                <span :style="paragraphOneFont" style="margin-top: 10vw">{{
                  steps[currentStep].age_title
                }}</span>
                <v-text-field
                  style="min-width: 160px; width: 22vw; margin-top: 1vw"
                  placeholder="Enter your age"
                  :style="paragraphTwoFont"
                  outlined
                  v-model="join_trials_inputs.age"
                  :rules="rules.ageRules"
                ></v-text-field>
                <span :style="paragraphOneFont" style="margin-top: 2vw">{{
                  steps[currentStep].gender_title
                }}</span>
                <v-radio-group
                  v-model="join_trials_inputs.gender"
                  row
                  :rules="rules.genderRules"
                >
                  <v-radio label="Male" value="male" color="#00857c"></v-radio>
                  <v-radio
                    label="Female"
                    value="female"
                    color="#00857c"
                  ></v-radio>
                </v-radio-group>
                <span :style="paragraphOneFont" style="margin-top: 2vw">{{
                  steps[currentStep].location_title
                }}</span>
                <v-text-field
                  style="min-width: 160px; width: 22vw; margin-top: 1vw"
                  :style="paragraphTwoFont"
                  placeholder="Enter your location or zip code"
                  outlined
                  v-model="join_trials_inputs.zip_code_or_location"
                  :rules="rules.locationRules"
                ></v-text-field>
              </v-form>
              <button
                v-if="currentStep < steps.length - 1"
                @click="goToFinalStep()"
              >
                Next
              </button>
            </div>
            <div v-if="currentStep === 2">
              <v-form ref="finalStepRef">
                <span :style="paragraphOneFont" style="margin-top: 10vw">{{
                  steps[currentStep].email_title
                }}</span>
                <v-row>
                  <v-col>
                    <v-text-field
                      style="min-width: 160px; width: 22vw; margin-top: 1vw"
                      placeholder="Enter your Email address"
                      :style="paragraphTwoFont"
                      outlined
                      v-model="join_trials_inputs.email"
                      :rules="rules.emailRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <span :style="paragraphOneFont" style="margin-top: 10vw">{{
                  steps[currentStep].phone_title
                }}</span>
                <v-row>
                  <v-col cols="auto">
                    <v-text-field
                      style="width: 4vw; margin-top: 1vw"
                      v-model="join_trials_inputs.country_code"
                      outlined
                      :rules="rules.countryCodeRules"
                    ></v-text-field
                  ></v-col>
                  <v-col>
                    <v-text-field
                      style="min-width: 160px; width: 17vw; margin-top: 1vw"
                      placeholder="Enter your number"
                      :style="paragraphTwoFont"
                      outlined
                      v-model="join_trials_inputs.phone"
                      :rules="rules.phoneRules"
                    ></v-text-field
                  ></v-col>
                </v-row>
              </v-form>
              <button
                v-if="currentStep === steps.length - 1"
                @click="submitForm()"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        conditionRules: [(v) => !!v || "Condition is required"],
        genderRules: [(v) => !!v || "Gender is required"],
        locationRules: [(v) => !!v || "Location is required"],
        countryCodeRules: [(v) => !!v || "Country code is required"],
        ageRules: [
          (v) => !!v || "Age is required",
          (v) => /^\d+(\.\d+)?$/.test(v) || "Age must be positive integer",
        ],
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        phoneRules: [
          (v) => !!v || "Phone number is required",
          (v) =>
            (v.length >= 7 && v.length <= 15) ||
            "Length must be between 7 and 15 characters",
        ],
        trialsForCheckboxRules: [
          (v) => this.atleastOneCheckboxChecked || "Must select at least one",
        ],
      },
      submitting: false,
      items: ["Parkinsons", "Parkinson desease", "Parkinsons trials"],
      currentStep: 0,
      join_trials_inputs: {
        condition: "",
        trials_for: [],
        age: undefined,
        gender: null,
        zip_code_or_location: "",
        email: "",
        phone: "",
        country_code: "+1",
      },
      steps: [
        {
          title: "For what condition are you looking to find a clinical trial?",
        },
        {
          checkbox_title: "1. For whom this trial is for?",
          age_title: "2. How old are you?",
          gender_title: "3. What is your biological gender?",
          location_title: "4. Enter your location or Zip code",
        },
        {
          email_title:
            "1. Want personalized trial alerts? Please provide you email for further alert.",
          phone_title: "2. What is your phone number? ",
        },
      ],
    };
  },
  watch: {
    "join_trials_inputs.for_me": {
      handler(value) {
        this.validateForm();
      },
    },
    "join_trials_inputs.for_someone": {
      handler(value) {
        this.validateForm();
      },
    },
  },
  methods: {
    validateForm() {
      this.$refs.secondStepRef.validate();
    },
    goToSecondStep() {
      if (this.$refs.firstStepRef.validate()) {
        if (this.currentStep < this.steps.length - 1) {
          this.currentStep++;
        }
      }
    },
    goToFinalStep() {
      if (this.$refs.secondStepRef.validate()) {
        if (this.currentStep < this.steps.length - 1) {
          this.currentStep++;
        }
      }
    },
    changeStep(index) {
      if (this.currentStep >= index) {
        this.currentStep = index;
      } else {
        if (this.currentStep === 0) {
          this.$refs.firstStepRef.validate();
        } else if (this.currentStep == 1) {
          this.$refs.secondStepRef.validate();
        } else this.$refs.finalStepRef.validate();
      }
    },
    async submitForm() {
      if (this.$refs.finalStepRef.validate()) {
        this.join_trials_inputs.email = this.join_trials_inputs.email.trim();
        this.$nextTick(() => {
          try {
            this.submitting = true;
            this.$store.dispatch("submitContactForm", {
              userData: this.join_trials_inputs,
            });
          } catch (e) {
            this.error = true;
            this.errorMessage = JSON.stringify(e);
            console.log(e);
          } finally {
            this.submitting = false;
            this.$router.push({ name: "thank-you-for-interest" });
          }
          //if not valid, errors will be automatically displayed
        });
      }
    },
  },
  computed: {
    atleastOneCheckboxChecked() {
      return this.join_trials_inputs.trials_for.length !== 0 ? true : false;
    },
    topLeftCard() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "width: 110px; height: 64px"; // Extra small screens (less than 600px)
        case "sm":
          return "width: 120px; height: 72px"; // Small screens (600px and up)
        case "md":
          return "width: 140px; height: 72px"; // Medium screens (960px and up)
        case "lg":
          return "width: 180px; height: 84px"; // Large screens (1264px and up)
        case "xl":
          return "width: 256px; height: 96px"; // Extra large screens (1904px and up)
        default:
          return "width: 256px; height: 96px";
      }
    },
    topRightCard() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "width: 320px; height: 64px"; // Extra small screens (less than 600px)
        case "sm":
          return "width: 440px; height: 72px"; // Small screens (600px and up)
        case "md":
          return "width: 640px; height: 72px"; // Medium screens (960px and up)
        case "lg":
          return "width: 860px; height: 84px"; // Large screens (1264px and up)
        case "xl":
          return "width: 1096px; height: 96px"; // Extra large screens (1904px and up)
        default:
          return "width: 1096px; height: 96px";
      }
    },
    headingFourFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 16px; line-height: 20px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 24px; line-height: 28px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    paragraphOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 14px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
    paragraphTwoFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 16px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 16px; line-height: 25px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 16px; line-height: 25px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 16px; line-height: 25px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.no-background-hover::before {
  background-color: transparent !important;
}

.stepper {
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.timeline {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  position: static;
}

.step {
  display: flex;
  align-items: flex-start;
  align-self: center;
  height: 113px;
  position: relative;
}

.step-icon {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background-color: #00857c;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
}

.step-content {
  margin-left: 7vw;
  padding: 20px;
  border-radius: 4px;
  width: 60vw;
  margin-bottom: 56px;
  align-self: center;
}

.step-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  width: 40vw;
}

button {
  background-color: #00857c;
  color: #fff;
  height: 48px;
  width: 96px;
  border-radius: 5px;
  cursor: pointer;
}

.line {
  width: 1px;
  height: 70%;
  background-color: #475560;
  position: absolute;
  left: 13px;
  top: 30px;
}

.active .step-icon {
  background-color: #ff7c45;
}
#stepper-parent {
  display: flex;
  position: relative;
  height: 31vw;
  align-self: center;
  padding: 0vw 6vw;
}
</style>
